// extracted by mini-css-extract-plugin
export default {"confirmationTabs":"material-confirmation-tabs_confirmationTabs__Z6RF9","actionBox":"material-confirmation-tabs_actionBox__1AiGF"};